import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Button, Spin } from "antd";
import moment from "jalali-moment";
import { StarOutlined } from "@ant-design/icons";
import { getWeedData, getWeedPrescriptionData } from "@services/api";
import {
  attackImpactRateConvertor,
  importanceRateConvertFromEnToFa,
  placingDataForEachElementBoxInEachPageUiHelper,
} from "@/components/reports/weedless/weedLessReportHelper";
import { FieldMarkerIcon } from "@/components/map/utils/customs";
import { toolbarBaseControls } from "@/features/map/utils/configs";
import AgroMapFarm from "@/features/map/presentation/components/AgroMapFarm";
import line from "@assets/images/weedless_report_images/Line185.png";
import frame2182 from "@assets/images/weedless_report_images/Frame2182.png";
import headerImage from "@assets/images/weedless_report_images/headerImage.png";
import footerImage from "@assets/images/weedless_report_images/footerImage.png";
import footerTitle from "@assets/images/weedless_report_images/footerTitle.png";
import weedlessIcon from "@assets/images/weedless_report_images/weedlessIcon.png";
function WeedLessReport() {
  const { id } = useParams();
  const [prescription, setPrescription] = useState({});
  const weedsData = useQuery({
    queryKey: ["getWeedsData", id],
    queryFn: () => getWeedData(null, 100, null, null),
  });
  const weedsPrescriptionData = useQuery({
    queryKey: ["getWeedPrescriptionData", id],
    queryFn: () => getWeedPrescriptionData(id),
  });

  useEffect(() => {
    setPrescription(weedsPrescriptionData?.data?.prescription);
  }, [weedsPrescriptionData?.data]);
  let weedsPrescriptionProperties;
  if (weedsPrescriptionData?.data) {
    weedsPrescriptionProperties = Object?.keys(
      weedsPrescriptionData?.data
    )?.reverse();
    let temp = weedsPrescriptionProperties[1];
    weedsPrescriptionProperties[1] = weedsPrescriptionProperties[2];
    weedsPrescriptionProperties[2] = temp;
  }
  const [prescriptionBoxHeight1, setPrescriptionBoxHeight1] = useState(0);
  const [prescriptionBoxHeight2, setPrescriptionBoxHeight2] = useState(0);
  const [prescriptionBoxHeight3, setPrescriptionBoxHeight3] = useState(0);
  const [counter, setCounter] = useState(0);
  let numberOfDynamicPages = [];
  let prescrptionWeeds;
  let pageNumber = 0;
  useEffect(() => {
    if (
      document?.getElementById("prescriptionTable1") &&
      document?.getElementById("prescriptionTable2") &&
      document?.getElementById("prescriptionTable3")
    ) {
      setPrescriptionBoxHeight1(
        document?.getElementById("prescriptionTable1")?.offsetHeight
      );
      setPrescriptionBoxHeight2(
        document?.getElementById("prescriptionTable2")?.offsetHeight
      );
      setPrescriptionBoxHeight3(
        document?.getElementById("prescriptionTable3")?.offsetHeight
      );
    }
  }, [
    document?.getElementById("prescriptionTable1"),
    document?.getElementById("prescriptionTable2"),
    document?.getElementById("prescriptionTable3"),
  ], []);

  useEffect(() => {
    if (
      prescriptionBoxHeight1 +
        prescriptionBoxHeight2 +
        prescriptionBoxHeight3 <=
        580 &&
      prescriptionBoxHeight1 !== 0 &&
      prescriptionBoxHeight2 !== 0 &&
      prescriptionBoxHeight3 !== 0
    ) {
      setCounter(1);
    } else if (
      prescriptionBoxHeight1 + prescriptionBoxHeight2 <= 750 &&
      prescriptionBoxHeight1 !== 0 &&
      prescriptionBoxHeight2 !== 0 &&
      prescriptionBoxHeight3 !== 0
    ) {
      setCounter(2);
    } else if (
      prescriptionBoxHeight1 !== 0 &&
      prescriptionBoxHeight2 !== 0 &&
      prescriptionBoxHeight3 !== 0
    ) {
      setCounter(3);
    }
  }, [prescriptionBoxHeight1, prescriptionBoxHeight2, prescriptionBoxHeight3]);
  for (let i = 0; i < counter; i++) {
    numberOfDynamicPages.push({ id: "test object" });
  }

  // تابع گروه‌بندی
  const groupPrescriptions = (prescriptions) => {
    const grouped = {};
    prescriptions.forEach((item) => {
      const key = `${item?.prescribedHerbicide?.brand || ""}-${
        item?.prescribedHerbicide?.formulation || ""
      }-${item?.prescribedHerbicide?.name || ""}-${
        item?.prescribedHerbicide?.dosage || ""
      }`;
      if (!grouped[key]) {
        grouped[key] = { ...item, weeds: [] };
      }
      grouped[key].weeds = [...grouped[key].weeds, ...(item?.weeds || [])];
    });
    return Object.values(grouped);
  };

  return (
    <>
      {weedsData?.isLoading && weedsPrescriptionData?.isLoading ? (
        <div className="flex flex-row items-center w-[500px] h-[500px] mx-auto my-[6rem]">
          <Spin
            className="spiner-loading-weed-management"
            style={{ margin: "auto" }}
            size="large"
          />
        </div>
      ) : (
        <div className="section-container flex flex-col items-center justify-center w-[720px] mx-auto !bg-white">
          {/* Page1 (Introduction) */}
          <div className="page1">
            <div className="flex flex-col justify-between items-center w-full h-[1048px]">
              <img
                className="header"
                src={headerImage}
                alt="header-image"
                width="750px"
              />
              <div className="flex flex-col justify-between items-center w-full gap-10 mb-96">
                <p
                  className="text-[#222] text-[29px] font-bold !font-[B-Nazanin] text-center"
                  style={{ textShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)" }}
                >
                  کشاورزی{" "}
                  <span className="text-weedless !font-[B-Nazanin]">
                    مطمئن‌
                    <span className="text-[#222] !font-[B-Nazanin]">تر، </span>
                  </span>
                  <span className="text-weedless !font-[B-Nazanin]">
                    دقیق‌
                    <span className="text-[#222] !font-[B-Nazanin]">تر و </span>
                  </span>
                  <span className="text-weedless !font-[B-Nazanin]">
                    اقتصادی‌
                    <span className="text-[#222] !font-[B-Nazanin]">تر</span>
                  </span>
                  <p className="text-[#000] font-semibold text-[20px] whitespace-nowrap !font-[B-Nazanin]">
                    هدف ما تصمیم‌گیری برای کشاورز نیست، کمک به تصمیم‌گیری بهتر
                    کشاورز است
                  </p>
                </p>
                <div className="flex flex-col items-center">
                  <img
                    src={weedlessIcon}
                    className="w-[287px] h-[296px] !font-[B-Nazanin]"
                    alt="weed-icon"
                  />
                  <span
                    className="text-weedless font-bold text-[40px] !font-[B-Nazanin]"
                    style={{
                      textShadow: "1px 0px 3px rgba(118, 118, 118, 0.61)",
                    }}
                  >
                    نسخه عمومی علف هرز
                  </span>
                </div>
                <img
                  src={line}
                  alt="line"
                  width="750px"
                  className="mt-[-80px] mr-0 mb-[-45px] ml-0"
                />
                <div className="flex flex-col gap-2 items-center justify-start w-full h-full">
                  <div className="flex flex-row-reverse justify-center items-start w-full gap-5 px-4">
                    <div className="flex flex-col justify-center items-end w-[50%] gap-2">
                      <div className="flex flex-row justify-end items-center gap-[19px] w-full"></div>
                    </div>
                    <div className="flex flex-col justify-center items-start w-[50%] gap-2">
                      <span className="font-bold text-[20px] text-[#222] mt-[-3px] !font-[B-Nazanin]">
                        اطلاعات کشاورز
                      </span>
                      <div className="flex flex-row-reverse justify-end items-center gap-[19px] w-full">
                        <div className="text-agrotext font-bold text-[18px] flex flex-col justify-center items-start gap-1">
                          <span className="!font-[B-Nazanin]">
                            {prescription?.farmer?.firstName}{" "}
                            {prescription?.farmer?.lastName}
                          </span>
                          <div className="flex flex-row items-start gap-2">
                            <span className="!font-[B-Nazanin]">
                              کد کشاورزی:
                            </span>
                            <span className="!font-sans text-[16px]">
                              {prescription?.farmer?.farmerCode}
                            </span>
                          </div>
                          <div className="flex flex-row items-start gap-2">
                            <span className="!font-[B-Nazanin]">
                              استان و شهر:
                            </span>
                            <span className="!font-[B-Nazanin]">
                              {prescription?.farmer?.province?.name}،{" "}
                              {prescription?.farmer?.city?.name}
                            </span>
                          </div>
                        </div>
                        <img
                          src={
                            process.env.REACT_APP_ARVAN_S3_BASE_URL +
                            prescription?.farmer?.avatar
                          }
                          alt="profile-image"
                          width="70px"
                          height="70px"
                          className="rounded-full border-[2px] border-solid border-weedless"
                        />
                      </div>
                    </div>
                  </div>
                  <img
                    src={line}
                    alt="line"
                    width="750px"
                    className="mt-[-45px] mr-0 mb-[-30px] ml-0"
                  />
                  <div className="flex flex-row justify-center items-center w-full px-4 p-2">
                    <div className="flex flex-col justify-center items-start w-[50%] gap-2">
                      <span className="font-bold text-[20px] text-[#222] !font-[B-Nazanin]">
                        اطلاعات زمین
                      </span>
                      <div className="flex flex-row-reverse justify-end items-center gap-[19px] w-full">
                        <div className="text-agrotext font-bold text-[18px] flex flex-col justify-center items-start gap-[6px]">
                          <div className="flex flex-row items-start gap-2">
                            <span className="!font-[B-Nazanin]">نام قطعه:</span>
                            <span className="!font-[B-Nazanin]">
                              {prescription?.season?.farm?.name}
                            </span>
                          </div>
                          <div className="flex flex-row items-start gap-2">
                            <span className="!font-[B-Nazanin]">استان:</span>
                            <span className="!font-[B-Nazanin]">
                              {prescription?.season?.farm?.province?.name}
                            </span>
                          </div>
                          <div className="flex flex-row items-start gap-2">
                            <span className="!font-[B-Nazanin]">شهر:</span>
                            <span className="!font-[B-Nazanin]">
                              {prescription?.season?.farm?.city?.name}
                            </span>
                          </div>
                        </div>
                        <div className="relative w-[80px] h-[80px] overflow-clip rounded-[999px]">
                          <div className="THISISFORMAPLOCK! bg-transparent z-[99999999] w-full h-full absolute"></div>
                          <AgroMapFarm
                            mapId={weedsPrescriptionData?.data?.farm?.id}
                            type="onlyShow"
                            toolbarOptions={toolbarBaseControls}
                            markerIcon={FieldMarkerIcon}
                            currentFarmPolygon={
                              weedsPrescriptionData?.data?.farm?.polygon
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col justify-center items-start w-[50%] gap-2">
                      <span className="font-bold text-[20px] text-[#222] !font-[B-Nazanin]">
                        اطلاعات فصل رشد
                      </span>
                      <div className="flex flex-row-reverse justify-end items-center gap-[19px] w-full">
                        <div className="text-agrotext font-bold text-[18px] flex flex-col justify-center items-start gap-[6px]">
                          <div className="flex flex-row items-start w-full justify-between gap-2">
                            <span className="!font-[B-Nazanin]">
                              نام محصول:
                            </span>
                            <span className="!font-[B-Nazanin]">
                              {prescription?.season?.product?.persianName}
                            </span>
                          </div>
                          <div className="flex flex-row items-start w-full justify-between gap-2 ">
                            <span className="!font-[B-Nazanin]">
                              مساحت زمین
                            </span>
                            <span className="!font-[B-Nazanin]">
                              {prescription?.season?.area} هکتار
                            </span>
                          </div>
                          <div className="flex flex-row items-start w-full justify-between gap-2">
                            <span className="!font-[B-Nazanin]">فصل رشد:</span>
                            <span className="!font-[B-Nazanin]">
                              {moment(
                                `${prescription?.season?.growingSeason}-04-01`,
                                "YYYY-MM-DD"
                              )
                                .locale("fa")
                                .format("YYYY")}{" "}
                              {prescription?.season?.persianName
                                ? ` - ${prescription?.season?.persianName}`
                                : ""}
                            </span>
                          </div>
                        </div>
                        <img
                          src={prescription?.season?.product?.imageUrl}
                          alt="product-name"
                          width="80px"
                          height="80px"
                          className="rounded-full"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer w-full flex flex-col justify-start items-center relative">
              <img
                className="absolute bottom-0 z-[2]"
                src={footerImage}
                width="750px"
                alt="footer-image"
              />
              <img
                className="absolute bottom-2 left-[30px] z-[3]"
                src={footerTitle}
                alt="footer-title-image"
              />
              <span className="absolute bottom-1 left-[60px] z-[3] text-[14px] font-bold text-[#fff] tracking-[7px] text-center">
                WWW.AGROYAAR.COM
              </span>
              <span className="absolute bottom-[5px] right-[15px] z-[3] text-[18px] font-semibold text-[#fff]">
                {++pageNumber}
              </span>
            </div>
          </div>
          {/* <!-- Page2 --> */}
          <div className="page2">
            <div className="flex flex-col justify-between items-center w-full h-[1048px] gap-20">
              <div className="header w-full relative h-[1048px]">
                <img
                  className="header"
                  src={frame2182}
                  alt="header-image"
                  width="720px"
                />
                <span className="absolute top-1 left-[20px] z-[3] text-[14px] font-bold text-[#fff] tracking-[7px] text-center">
                  WWW.AGROYAAR.COM
                </span>

                <div className="flex flex-col justify-center items-start w-full gap-2 px-4">
                  <span className="font-bold text-[20px] text-[#222] !font-[B-Nazanin]">
                    علف های هرز انتخاب شده
                  </span>
                  <div className="flex flex-wrap justify-start items-center gap-y-5 w-full">
                    {weedsData?.data?.weeds
                      ?.filter((weed) =>
                        prescription?.weeds?.find(
                          (weedItem) => weed?.id === weedItem?.weedId
                        )
                      )
                      ?.map((weed, i) => {
                        return (
                          <div
                            key={i}
                            className="flex flex-row-reverse items-center justify-end gap-[10px] w-[340px]"
                          >
                            <div className="text-agrotext font-bold text-[18px] flex flex-col justify-center items-start gap-[6px]">
                              <div className="flex flex-row items-start gap-2">
                                <span className="!font-[B-Nazanin]">
                                  نام علف هرز:
                                </span>
                                <span className="!font-[B-Nazanin]">
                                  {weed?.name}
                                </span>
                              </div>
                              <div className="flex flex-row items-start gap-2">
                                <span className="!font-[B-Nazanin]">
                                  میزان علف هرز:
                                </span>
                                <span className="!font-[B-Nazanin]">
                                  {importanceRateConvertFromEnToFa(
                                    prescription?.weeds?.find(
                                      (weedItem) =>
                                        weed?.id === weedItem?.weedId
                                    )?.abundanceRate
                                  )}
                                </span>
                              </div>
                            </div>
                            <img
                              className="rounded-full w-[80px] h-[80px]"
                              src={
                                process.env.REACT_APP_ARVAN_S3_BASE_URL +
                                weed?.images[0]
                              }
                              alt={weed?.name}
                            />
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-12 h-[1048px] w-[670px] font-semibold !font-[B-Nazanin]">
                <div className="flex flex-col gap-2">
                  <p className="text-lg !font-[B-Nazanin] text-[#202020]">
                    راهنمای گزارش علف‌های هرز
                  </p>
                  <ul className="flex flex-col gap-2 list-disc list-inside">
                    <li className="!font-[B-Nazanin] text-[#202020] leading-7">
                      کشاورز گرامی، این گزارش بر اساس اطلاعاتی که شما درباره
                      محصول و علف‌های هرز مزرعه خود وارد کرده‌اید، به‌صورت
                      هوشمند تهیه شده است. سیستم با استفاده از منابع علمی معتبر،
                      سه نسخه پیشنهادی برای کنترل شیمیایی علف‌های هرز ارائه
                      می‌دهد.
                    </li>
                    <li className="!font-[B-Nazanin] text-[#202020] leading-7">
                      توجه داشته باشید که این نسخه‌ها صرفاً پیشنهادهای فنی و
                      مطابق با منابع علمی هستند و پیش از هرگونه مصرف علف‌کش،
                      لازم است با کارشناس گیاه‌پزشکی منطقه خود مشورت نمایید تا
                      نسخه مناسب با شرایط خاک، آب، اقلیم و نوع کشت شما انتخاب
                      شود. در انتهای گزارش، منابع علمی مورد استفاده در تدوین
                      نسخه‌ها ذکر شده‌اند.
                    </li>
                  </ul>
                </div>

                <div className="border-[3px] border-[#4D6E06] border-dashed rounded-xl p-3">
                  <p className="!font-[B-Nazanin] leading-7">
                    این سامانه با تحلیل نوع محصول و علف‌های هرز هر مزرعه و
                    استفاده از منابع علمی معتبر، به تصمیم‌گیری آگاهانه کشاورز و
                    افزایش دقت در مدیریت علف‌های هرز کمک می‌کند.
                  </p>
                </div>
              </div>

              <div className="footer w-full flex flex-col justify-start items-center relative bottom-0">
                <img
                  className="absolute bottom-0 z-[2]"
                  src={footerImage}
                  width="750px"
                  alt="footer-image"
                />
                <img
                  className="absolute bottom-2 left-[30px] z-[3]"
                  src={footerTitle}
                  alt="footer-image"
                />
                <span className="absolute bottom-[5px] left-[30px] z-[3] text-[12px] font-bold text-[#fff] !font-sans">
                  کد علف هرز: {prescription?.prescriptionCode}
                </span>
                <span className="absolute bottom-[5px] right-[15px] z-[3] text-[18px] font-semibold text-[#fff]">
                  {++pageNumber}
                </span>
              </div>
            </div>
          </div>
          {/* <!-- Page3 --> tables of prescription */}
          {prescriptionBoxHeight1 !== 0 &&
          prescriptionBoxHeight2 !== 0 &&
          prescriptionBoxHeight3 !== 0 ? (
            numberOfDynamicPages.map((page, i) => {
              const {
                showPrescriptionElementBox1,
                showPrescriptionElementBox2,
                showPrescriptionElementBox3,
              } = placingDataForEachElementBoxInEachPageUiHelper(
                numberOfDynamicPages.length,
                i
              );
              return (
                <div key={i} className="page3">
                  <div className="flex flex-col justify-between items-center w-full h-[1048px] gap-3">
                    <div className="header w-full relative">
                      <img
                        className="header"
                        src={frame2182}
                        alt="header-image"
                        width="720px"
                      />
                      <span className="absolute top-1 left-[20px] z-[3] text-[14px] font-bold text-[#fff] tracking-[7px] text-center">
                        WWW.AGROYAAR.COM
                      </span>
                    </div>
                    <div className="flex flex-col items-start justify-start w-full h-full px-4 mt-[-7px]">
                      <div className="flex flex-col items-start justify-center gap-4 w-full">
                        {i === 0 && (
                          <p className="!font-[B-Nazanin] mx-auto px-4 py-1 text-[18px] font-bold text-[#222] rounded-[15px] bg-[#D2E4AD]">
                            متقاضی عزیز، شما میتوانید{" "}
                            <span className="text-[#4E6F04] !font-[B-Nazanin]">
                              یکی از نسخه‌های پیشنهادی
                            </span>{" "}
                            زیر را با نظر گیاهپزشک حاذق منطقه خودتان استفاده
                            نمائید.
                          </p>
                        )}
                        {weedsPrescriptionProperties?.map((key, j) => {
                          switch (key) {
                            case "generatedPrescriptionByMinimumHerbicideAndAttackImpactRate":
                              prescrptionWeeds = [];
                              const grouped1 = groupPrescriptions(
                                weedsPrescriptionData?.data
                                  ?.generatedPrescriptionByMinimumHerbicideAndAttackImpactRate ||
                                  []
                              );
                              grouped1.forEach((item) => {
                                item?.weeds?.forEach((weed) => {
                                  prescrptionWeeds.push({
                                    id: weed?.weedId,
                                    name: weed?.name,
                                    attackImpactRate:
                                      weed?.effectiveHerbicide
                                        ?.attackImpactRate,
                                  });
                                });
                              });
                              return (
                                <>
                                  {showPrescriptionElementBox1 && (
                                    <div
                                      key={j}
                                      id="prescriptionTable1"
                                      className="flex flex-col items-center gap-1"
                                    >
                                      <p className="!font-[B-Nazanin] px-4 font-bold text-[#162001] text-[20px]">
                                        <span className="text-[#4E6F04] !font-[B-Nazanin]">
                                          نسخه پیشنهادی 1:
                                        </span>{" "}
                                        (نسخه بهینه بر اساس علف کش کمتر و اثر
                                        گذاری بیشتر)
                                      </p>
                                      <p className="!font-[B-Nazanin] text-sm">
                                        ترکیبی متعادل از علف‌کش‌ها که با مقدار
                                        مصرف کمتر و اثرگذاری بالا طراحی شده تا
                                        هم از نظر اقتصادی مقرون‌به‌صرفه باشد و
                                        هم کنترل مؤثر علف‌های هرز را فراهم کند.
                                      </p>
                                      <div className="flex flex-col items-start justify-start gap-3 border-[3px] border-solid rounded-[20px] border-weedless">
                                        <table
                                          style={{
                                            borderCollapse: "separate",
                                            borderSpacing: 2,
                                          }}
                                        >
                                          <thead>
                                            <tr>
                                              <th className="w-[120px] py-1 !font-[B-Nazanin] text-[14px] text-center rounded-tr-[16px] weedless-report-header">
                                                نام تجاری
                                              </th>
                                              <th className="w-[130px] !font-[B-Nazanin] text-[14px] text-center weedless-report-header">
                                                نام عمومی
                                              </th>
                                              <th className="w-[150px] !font-[B-Nazanin] text-[14px] text-center weedless-report-header">
                                                مقدار مصرف در هکتار
                                              </th>
                                              <th className="w-[150px] !font-[B-Nazanin] text-[14px] text-center weedless-report-header">
                                                زمان مصرف
                                              </th>
                                              <th className="w-[160px] !font-[B-Nazanin] text-[14px] text-center rounded-tl-[16px] weedless-report-header">
                                                علف های هرز قابل کنترل
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {grouped1.map((item, k) => {
                                              const uniqueInstructions = [
                                                ...new Set(
                                                  item.weeds.map(
                                                    (weed) =>
                                                      weed?.effectiveHerbicide
                                                        ?.instruction || ""
                                                  )
                                                ),
                                              ];
                                              const weedNames = item.weeds.map(
                                                (weed) => weed?.name || ""
                                              );
                                              return (
                                                <tr
                                                  key={k}
                                                  className={`${
                                                    k % 2 !== 0 &&
                                                    "bg-[#E9E9E9]"
                                                  }`}
                                                >
                                                  <td className="w-[120px] text-center !font-[B-Nazanin] text-[14px] font-semibold px-2">
                                                    {
                                                      item?.prescribedHerbicide
                                                        ?.brand
                                                    }
                                                    <br />
                                                    {
                                                      item?.prescribedHerbicide
                                                        ?.formulation
                                                    }
                                                  </td>
                                                  <td className="w-[130px] text-center !font-[B-Nazanin] text-[14px] px-2 font-medium">
                                                    {
                                                      item?.prescribedHerbicide
                                                        ?.name
                                                    }
                                                  </td>
                                                  <td className="w-[150px] text-center !font-[B-Nazanin] text-[14px] px-2 font-medium">
                                                    {
                                                      item?.prescribedHerbicide
                                                        ?.dosage
                                                    }
                                                  </td>
                                                  <td className="w-[150px] text-center !font-[B-Nazanin] text-[14px] px-2 font-medium">
                                                    {uniqueInstructions.join(
                                                      " - "
                                                    )}
                                                  </td>
                                                  <td className="w-[160px] text-center text-[14px] px-2 font-medium !font-[B-Nazanin]">
                                                    {weedNames.join(" ، ")}
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                          </tbody>
                                        </table>
                                        <div className="flex flex-col items-start p-[15px]">
                                          <div className="flex flex-row items-start gap-2">
                                            <StarOutlined className="mt-0.5" />
                                            <p className="!font-[B-Nazanin]">
                                              با توجه به منابع علمی، میزان اثر
                                              بخشی این نسخه روی{" "}
                                              {prescrptionWeeds.length === 1
                                                ? "علف هرز"
                                                : "علف های هرز"}{" "}
                                              <span className="font-bold">
                                                <u className="!font-[B-Nazanin]">
                                                  {prescrptionWeeds.map(
                                                    (weed, k) =>
                                                      prescrptionWeeds.length -
                                                        1 !==
                                                      k
                                                        ? `${
                                                            weed?.name
                                                          } ${attackImpactRateConvertor(
                                                            weed?.attackImpactRate
                                                          )}، `
                                                        : `${
                                                            weed?.name
                                                          } ${attackImpactRateConvertor(
                                                            weed?.attackImpactRate
                                                          )} `
                                                  )}
                                                </u>
                                              </span>{" "}
                                              است.
                                            </p>
                                          </div>
                                          {/* <p className='!font-[B-Nazanin] tracking-tight'><span className='font-bold !font-[B-Nazanin]'>غیر قابل اختلاط:</span> علف کش گالانت سوپر و علف کش پنترا قابلیت اختلاط با یکدیگر را ندارند و لازم است به صورت جداگانه سمپاشی شوند.</p> */}
                                          {/* <p className='!font-[B-Nazanin] text-[#222]'><span className='font-bold !font-[B-Nazanin]'>نکته:</span> علف کش پنترا برای ماهی ها و پرندگان سمیت زیادی دارد.</p> */}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </>
                              );
                            case "generatedPrescriptionByMinimumHerbicide":
                              prescrptionWeeds = [];
                              const grouped2 = groupPrescriptions(
                                weedsPrescriptionData?.data
                                  ?.generatedPrescriptionByMinimumHerbicide ||
                                  []
                              );
                              grouped2.forEach((item) => {
                                item?.weeds?.forEach((weed) => {
                                  prescrptionWeeds.push({
                                    id: weed?.weedId,
                                    name: weed?.name,
                                    attackImpactRate:
                                      weed?.effectiveHerbicide
                                        ?.attackImpactRate,
                                  });
                                });
                              });
                              return (
                                <>
                                  {showPrescriptionElementBox2 && (
                                    <div
                                      key={j}
                                      id="prescriptionTable2"
                                      className="flex flex-col items-center gap-2"
                                    >
                                      <p className="!font-[B-Nazanin] px-4 font-bold text-[#222] text-[20px]">
                                        <span className="text-[#4E6F04] !font-[B-Nazanin]">
                                          نسخه پیشنهادی 2:
                                        </span>{" "}
                                        (بر اساس مصرف کمترین علف کش)
                                      </p>
                                      <p className="!font-[B-Nazanin] text-sm">
                                        در این نسخه، حداقل مقدار علف‌کش ممکن
                                        پیشنهاد شده است تا مصرف مواد شیمیایی در
                                        مزرعه کاهش یابد و اثرات زیست‌محیطی به
                                        حداقل برسد.
                                      </p>
                                      <div className="flex flex-col items-start justify-start gap-3 border-[3px] border-solid rounded-[20px] border-weedless">
                                        <table
                                          style={{
                                            borderCollapse: "separate",
                                            borderSpacing: 2,
                                          }}
                                        >
                                          <thead>
                                            <tr>
                                              <th className="w-[120px] py-1 !font-[B-Nazanin] text-[14px] text-center rounded-tr-[16px] weedless-report-header">
                                                نام تجاری
                                              </th>
                                              <th className="w-[130px] !font-[B-Nazanin] text-[14px] text-center weedless-report-header">
                                                نام عمومی
                                              </th>
                                              <th className="w-[150px] !font-[B-Nazanin] text-[14px] text-center weedless-report-header">
                                                مقدار مصرف در هکتار
                                              </th>
                                              <th className="w-[150px] !font-[B-Nazanin] text-[14px] text-center weedless-report-header">
                                                زمان مصرف
                                              </th>
                                              <th className="w-[160px] !font-[B-Nazanin] text-[14px] text-center rounded-tl-[16px] weedless-report-header">
                                                علف های هرز قابل کنترل
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {grouped2.map((item, k) => {
                                              const uniqueInstructions = [
                                                ...new Set(
                                                  item.weeds.map(
                                                    (weed) =>
                                                      weed?.effectiveHerbicide
                                                        ?.instruction || ""
                                                  )
                                                ),
                                              ];
                                              const weedNames = item.weeds.map(
                                                (weed) => weed?.name || ""
                                              );
                                              return (
                                                <tr
                                                  key={k}
                                                  className={`${
                                                    k % 2 !== 0 &&
                                                    "bg-[#E9E9E9]"
                                                  }`}
                                                >
                                                  <td className="w-[120px] text-center !font-[B-Nazanin] text-[14px] font-semibold px-2">
                                                    {
                                                      item?.prescribedHerbicide
                                                        ?.brand
                                                    }
                                                    <br />
                                                    {
                                                      item?.prescribedHerbicide
                                                        ?.formulation
                                                    }
                                                  </td>
                                                  <td className="w-[130px] text-ellipsis text-center !font-[B-Nazanin] text-[14px] px-2 font-medium">
                                                    {
                                                      item?.prescribedHerbicide
                                                        ?.name
                                                    }
                                                  </td>
                                                  <td className="w-[150px] text-center !font-[B-Nazanin] text-[14px] px-2 font-medium">
                                                    {
                                                      item?.prescribedHerbicide
                                                        ?.dosage
                                                    }
                                                  </td>
                                                  <td className="w-[150px] text-center !font-[B-Nazanin] text-[14px] px-2 font-medium">
                                                    {uniqueInstructions.join(
                                                      " - "
                                                    )}
                                                  </td>
                                                  <td className="w-[160px] text-center text-[14px] px-2 font-medium !font-[B-Nazanin]">
                                                    {weedNames.join(" ، ")}
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                          </tbody>
                                        </table>
                                        <div className="flex flex-col items-start p-[15px]">
                                          <div className="flex flex-row items-start gap-2">
                                            <StarOutlined className="mt-0.5" />
                                            <p className="!font-[B-Nazanin]">
                                              با توجه به منابع علمی، میزان اثر
                                              بخشی این نسخه روی{" "}
                                              {prescrptionWeeds.length === 1
                                                ? "علف هرز"
                                                : "علف های هرز"}{" "}
                                              <span className="font-bold">
                                                <u className="!font-[B-Nazanin]">
                                                  {prescrptionWeeds.map(
                                                    (weed, k) =>
                                                      prescrptionWeeds.length -
                                                        1 !==
                                                      k
                                                        ? `${
                                                            weed?.name
                                                          } ${attackImpactRateConvertor(
                                                            weed?.attackImpactRate
                                                          )}، `
                                                        : `${
                                                            weed?.name
                                                          } ${attackImpactRateConvertor(
                                                            weed?.attackImpactRate
                                                          )} `
                                                  )}
                                                </u>
                                              </span>{" "}
                                              است.
                                            </p>
                                          </div>
                                          {/* <p className='!font-[B-Nazanin] tracking-tight'><span className='font-bold !font-[B-Nazanin]'>غیر قابل اختلاط:</span> علف کش گالانت سوپر و علف کش پنترا قابلیت اختلاط با یکدیگر را ندارند و لازم است به صورت جداگانه سمپاشی شوند.</p> */}
                                          {/* <p className='!font-[B-Nazanin] text-[#222]'><span className='font-bold !font-[B-Nazanin]'>نکته:</span> علف کش پنترا برای ماهی ها و پرندگان سمیت زیادی دارد.</p> */}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </>
                              );
                            case "generatedPrescriptionByAttackImpactRate":
                              prescrptionWeeds = [];
                              const grouped3 = groupPrescriptions(
                                weedsPrescriptionData?.data
                                  ?.generatedPrescriptionByAttackImpactRate ||
                                  []
                              );
                              grouped3.forEach((item) => {
                                item?.weeds?.forEach((weed) => {
                                  prescrptionWeeds.push({
                                    id: weed?.weedId,
                                    name: weed?.name,
                                    attackImpactRate:
                                      weed?.effectiveHerbicide
                                        ?.attackImpactRate,
                                  });
                                });
                              });
                              return (
                                <>
                                  {showPrescriptionElementBox3 && (
                                    <div
                                      key={j}
                                      id="prescriptionTable3"
                                      className="flex flex-col items-center gap-2"
                                    >
                                      <p className="!font-[B-Nazanin] px-4 font-bold text-[#222] text-[20px]">
                                        <span className="text-[#4E6F04] !font-[B-Nazanin]">
                                          نسخه پیشنهادی 3:
                                        </span>{" "}
                                        (بر اساس بیشترین اثر گذاری بر کنترل علف
                                        هرز)
                                      </p>
                                      <p className="!font-[B-Nazanin] text-sm">
                                        این نسخه بر اساس بیشترین توان کنترل
                                        علف‌های هرز تهیه شده ولی می‌تواند از نظر
                                        اقتصادی یا اثرات زیست‌محیطی مناسب نباشد.
                                      </p>
                                      <div className="flex flex-col items-start justify-start gap-3 border-[3px] border-solid rounded-[20px] border-weedless">
                                        <table
                                          style={{
                                            borderCollapse: "separate",
                                            borderSpacing: 2,
                                          }}
                                        >
                                          <thead>
                                            <tr>
                                              <th className="w-[120px] py-1 !font-[B-Nazanin] text-[14px] text-center rounded-tr-[16px] weedless-report-header">
                                                نام تجاری
                                              </th>
                                              <th className="w-[130px] !font-[B-Nazanin] text-[14px] text-center weedless-report-header">
                                                نام عمومی
                                              </th>
                                              <th className="w-[150px] !font-[B-Nazanin] text-[14px] text-center weedless-report-header">
                                                مقدار مصرف در هکتار
                                              </th>
                                              <th className="w-[150px] !font-[B-Nazanin] text-[14px] text-center weedless-report-header">
                                                زمان مصرف
                                              </th>
                                              <th className="w-[160px] !font-[B-Nazanin] text-[14px] text-center rounded-tl-[16px] weedless-report-header">
                                                علف های هرز قابل کنترل
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {grouped3.map((item, k) => {
                                              const uniqueInstructions = [
                                                ...new Set(
                                                  item.weeds.map(
                                                    (weed) =>
                                                      weed?.effectiveHerbicide
                                                        ?.instruction || ""
                                                  )
                                                ),
                                              ];
                                              const weedNames = item.weeds.map(
                                                (weed) => weed?.name || ""
                                              );
                                              return (
                                                <tr
                                                  key={k}
                                                  className={`${
                                                    k % 2 !== 0 &&
                                                    "bg-[#E9E9E9]"
                                                  }`}
                                                >
                                                  <td className="w-[120px] text-center !font-[B-Nazanin] text-[14px] font-semibold px-2">
                                                    {
                                                      item?.prescribedHerbicide
                                                        ?.brand
                                                    }
                                                    <br />
                                                    {
                                                      item?.prescribedHerbicide
                                                        ?.formulation
                                                    }
                                                  </td>
                                                  <td className="w-[130px] text-center !font-[B-Nazanin] text-[14px] px-2 font-medium">
                                                    {
                                                      item?.prescribedHerbicide
                                                        ?.name
                                                    }
                                                  </td>
                                                  <td className="w-[150px] text-center !font-[B-Nazanin] text-[14px] px-2 font-medium">
                                                    {
                                                      item?.prescribedHerbicide
                                                        ?.dosage
                                                    }
                                                  </td>
                                                  <td className="w-[150px] text-center !font-[B-Nazanin] text-[14px] px-2 font-medium">
                                                    {uniqueInstructions.join(
                                                      " - "
                                                    )}
                                                  </td>
                                                  <td className="w-[160px] text-center text-[14px] px-2 font-medium !font-[B-Nazanin]">
                                                    {weedNames.join(" ، ")}
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                          </tbody>
                                        </table>
                                        <div className="flex flex-col items-start p-[15px]">
                                          <div className="flex flex-row items-start gap-2">
                                            <StarOutlined className="mt-0.5" />
                                            <p className="!font-[B-Nazanin]">
                                              با توجه به منابع علمی، میزان اثر
                                              بخشی این نسخه روی{" "}
                                              {prescrptionWeeds.length === 1
                                                ? "علف هرز"
                                                : "علف های هرز"}{" "}
                                              <span className="font-bold">
                                                <u className="!font-[B-Nazanin]">
                                                  {prescrptionWeeds.map(
                                                    (weed, k) =>
                                                      prescrptionWeeds.length -
                                                        1 !==
                                                      k
                                                        ? `${
                                                            weed?.name
                                                          } ${attackImpactRateConvertor(
                                                            weed?.attackImpactRate
                                                          )}، `
                                                        : `${
                                                            weed?.name
                                                          } ${attackImpactRateConvertor(
                                                            weed?.attackImpactRate
                                                          )} `
                                                  )}
                                                </u>
                                              </span>{" "}
                                              است.
                                            </p>
                                          </div>
                                          {/* <p className='!font-[B-Nazanin] tracking-tight'><span className='font-bold !font-[B-Nazanin]'>غیر قابل اختلاط:</span> علف کش گالانت سوپر و علف کش پنترا قابلیت اختلاط با یکدیگر را ندارند و لازم است به صورت جداگانه سمپاشی شوند.</p> */}
                                          {/* <p className='!font-[B-Nazanin] text-[#222]'><span className='font-bold !font-[B-Nazanin]'>نکته:</span> علف کش پنترا برای ماهی ها و پرندگان سمیت زیادی دارد.</p> */}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </>
                              );
                            default:
                              break;
                          }
                        })}
                      </div>
                    </div>
                    {numberOfDynamicPages.length - 1 === i && (
                      <div className="flex flex-col items-start justify-center gap-2 w-[670px] mb-[7rem]">
                        <p className="font-semibold">منابع این نسخه:</p>
                        <div>
                          <ul className="list-disc list-inside">
                            <li className="!font-[B-Nazanin] leading-7">
                              زند، ا.، ن. نظام‌آبادی.، م. ع. باغستانی میبدی، پ.
                              شیمی و س. ک. موسوی. 1398. راهنمای کنترل شیمیایی
                              علف‌های هرز ایران (ویراست ششم). جهاد دانشگاهی
                              مشهد. 216ص.{" "}
                            </li>
                            <li className="!font-[B-Nazanin] leading-7">
                              شیمی، پ. و ف. ترمه. 1385. اطلس علف‌های هرز مهم
                              ایران. سازمان تحقیقات و آموزش کشاورزی. 151ص.
                            </li>
                          </ul>
                        </div>
                        <div style={{ direction: "ltr" }}>
                          <ul className="list-disc list-inside leading-7">
                            <li className="!font-[B-Nazanin]">
                              Ahrens, W.H. 1994. Herbicide Handbook. Weed
                              Science Society of America. Pp 352.
                            </li>
                            <li className="!font-[B-Nazanin] leading-7">
                              Anonymous. 1997. Herbicide guide. South African
                              Sugar Association Experiment Station.
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                    <div className="footer w-full flex flex-col justify-start items-center relative bottom-0">
                      <img
                        className="absolute bottom-0 z-[2]"
                        src={footerImage}
                        width="750px"
                        alt="footer-image"
                      />
                      <img
                        className="absolute bottom-2 left-[30px] z-[3]"
                        src={footerTitle}
                        alt="footer-image"
                      />
                      <span className="absolute bottom-[5px] left-[30px] z-[3] text-[12px] font-bold text-[#fff] !font-sans">
                        کد علف هرز: {prescription?.prescriptionCode}
                      </span>
                      <span className="absolute bottom-[5px] right-[15px] z-[3] text-[18px] font-semibold text-[#fff]">
                        {++pageNumber}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="page3">
              <div className="flex flex-col justify-between items-center w-full h-[1048px]">
                <img
                  className="header"
                  src={frame2182}
                  alt="header-image"
                  width="750px"
                />
                <div className="flex flex-col items-start justify-start w-full h-full gap-8 px-2">
                  <div className="flex flex-col items-start justify-center w-full gap-6">
                    <p className="!font-[B-Nazanin] mx-auto px-4 py-1 text-[18px] font-bold text-[#222] rounded-[15px] bg-[#D2E4AD]">
                      متقاضی عزیز، شما میتوانید{" "}
                      <span className="text-[#4E6F04] !font-[B-Nazanin]">
                        یکی از نسخه‌های پیشنهادی
                      </span>{" "}
                      زیر را با نظر گیاهپزشک حاذق منطقه خودتان استفاده نمائید.
                    </p>
                    {weedsPrescriptionProperties?.map((key, j) => {
                      switch (key) {
                        case "generatedPrescriptionByMinimumHerbicideAndAttackImpactRate":
                          prescrptionWeeds = [];
                          const grouped1 = groupPrescriptions(
                            weedsPrescriptionData?.data
                              ?.generatedPrescriptionByMinimumHerbicideAndAttackImpactRate ||
                              []
                          );
                          grouped1.forEach((item) => {
                            item?.weeds?.forEach((weed) => {
                              prescrptionWeeds.push({
                                id: weed?.weedId,
                                name: weed?.name,
                                attackImpactRate:
                                  weed?.effectiveHerbicide?.attackImpactRate,
                              });
                            });
                          });
                          return (
                            <div
                              key={j}
                              id="prescriptionTable1"
                              className="flex flex-col items-start gap-2"
                            >
                              <p className="!font-[B-Nazanin] px-4 font-bold text-[#162001] text-[20px]">
                                <span className="text-[#4E6F04] !font-[B-Nazanin]">
                                  نسخه پیشنهادی 1:
                                </span>{" "}
                                (نسخه بهینه بر اساس علف کش کمتر و اثر گذاری
                                بیشتر)
                              </p>
                              <div className="flex flex-col items-start justify-start gap-3 border-[3px] border-solid rounded-[20px] border-weedless">
                                <table
                                  style={{
                                    borderCollapse: "separate",
                                    borderSpacing: 2,
                                  }}
                                >
                                  <thead>
                                    <tr>
                                      <th className="w-[120px] py-1 !font-[B-Nazanin] text-[14px] text-center rounded-tr-[16px] weedless-report-header">
                                        نام تجاری
                                      </th>
                                      <th className="w-[130px] !font-[B-Nazanin] text-[14px] text-center weedless-report-header">
                                        نام عمومی
                                      </th>
                                      <th className="w-[150px] !font-[B-Nazanin] text-[14px] text-center weedless-report-header">
                                        مقدار مصرف در هکتار
                                      </th>
                                      <th className="w-[150px] !font-[B-Nazanin] text-[14px] text-center weedless-report-header">
                                        زمان مصرف
                                      </th>
                                      <th className="w-[160px] !font-[B-Nazanin] text-[14px] text-center rounded-tl-[16px] weedless-report-header">
                                        علف های هرز قابل کنترل
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {grouped1.map((item, k) => {
                                      const uniqueInstructions = [
                                        ...new Set(
                                          item.weeds.map(
                                            (weed) =>
                                              weed?.effectiveHerbicide
                                                ?.instruction || ""
                                          )
                                        ),
                                      ];
                                      const weedNames = item.weeds.map(
                                        (weed) => weed?.name || ""
                                      );
                                      return (
                                        <tr
                                          key={k}
                                          className={`${
                                            k % 2 !== 0 && "bg-[#E9E9E9]"
                                          }`}
                                        >
                                          <td className="w-[120px] text-center !font-[B-Nazanin] text-[14px] font-semibold px-2">
                                            {item?.prescribedHerbicide?.brand}
                                            <br />
                                            {
                                              item?.prescribedHerbicide
                                                ?.formulation
                                            }
                                          </td>
                                          <td className="w-[130px] text-center !font-[B-Nazanin] text-[14px] px-2 font-medium">
                                            {item?.prescribedHerbicide?.name}
                                          </td>
                                          <td className="w-[150px] text-center !font-[B-Nazanin] text-[14px] px-2 font-medium">
                                            {item?.prescribedHerbicide?.dosage}
                                          </td>
                                          <td className="w-[150px] text-center !font-[B-Nazanin] text-[14px] px-2 font-medium">
                                            {uniqueInstructions.join(" - ")}
                                          </td>
                                          <td className="w-[160px] text-center text-[14px] px-2 font-medium !font-[B-Nazanin]">
                                            {weedNames.join(" ، ")}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                                <div className="flex flex-col items-start p-[15px]">
                                  <div className="flex flex-row items-start gap-2">
                                    <StarOutlined className="mt-0.5" />
                                    <p className="!font-[B-Nazanin]">
                                      با توجه به منابع علمی، میزان اثر بخشی این
                                      نسخه روی{" "}
                                      {prescrptionWeeds.length === 1
                                        ? "علف هرز"
                                        : "علف های هرز"}{" "}
                                      <span className="font-bold">
                                        <u className="!font-[B-Nazanin]">
                                          {prescrptionWeeds.map((weed, k) =>
                                            prescrptionWeeds.length - 1 !== k
                                              ? `${
                                                  weed?.name
                                                } ${attackImpactRateConvertor(
                                                  weed?.attackImpactRate
                                                )}، `
                                              : `${
                                                  weed?.name
                                                } ${attackImpactRateConvertor(
                                                  weed?.attackImpactRate
                                                )} `
                                          )}
                                        </u>
                                      </span>{" "}
                                      است.
                                    </p>
                                  </div>
                                  {/* <p className='!font-[B-Nazanin] tracking-tight'><span className='font-bold !font-[B-Nazanin]'>غیر قابل اختلاط:</span> علف کش گالانت سوپر و علف کش پنترا قابلیت اختلاط با یکدیگر را ندارند و لازم است به صورت جداگانه سمپاشی شوند.</p> */}
                                  {/* <p className='!font-[B-Nazanin] text-[#222]'><span className='font-bold !font-[B-Nazanin]'>نکته:</span> علف کش پنترا برای ماهی ها و پرندگان سمیت زیادی دارد.</p> */}
                                </div>
                              </div>
                            </div>
                          );
                        case "generatedPrescriptionByMinimumHerbicide":
                          prescrptionWeeds = [];
                          const grouped2 = groupPrescriptions(
                            weedsPrescriptionData?.data
                              ?.generatedPrescriptionByMinimumHerbicide || []
                          );
                          grouped2.forEach((item) => {
                            item?.weeds?.forEach((weed) => {
                              prescrptionWeeds.push({
                                id: weed?.weedId,
                                name: weed?.name,
                                attackImpactRate:
                                  weed?.effectiveHerbicide?.attackImpactRate,
                              });
                            });
                          });
                          return (
                            <div
                              key={j}
                              id="prescriptionTable2"
                              className="flex flex-col items-start gap-2"
                            >
                              <p className="!font-[B-Nazanin] px-4 font-bold text-[#222] text-[20px]">
                                <span className="text-[#4E6F04] !font-[B-Nazanin]">
                                  نسخه پیشنهادی 2:
                                </span>{" "}
                                (بر اساس مصرف کمترین علف کش)
                              </p>
                              <div className="flex flex-col items-start justify-start gap-3 border-[3px] border-solid rounded-[20px] border-weedless">
                                <table
                                  style={{
                                    borderCollapse: "separate",
                                    borderSpacing: 2,
                                  }}
                                >
                                  <thead>
                                    <tr>
                                      <th className="w-[120px] py-1 !font-[B-Nazanin] text-[14px] text-center rounded-tr-[16px] weedless-report-header">
                                        نام تجاری
                                      </th>
                                      <th className="w-[130px] !font-[B-Nazanin] text-[14px] text-center weedless-report-header">
                                        نام عمومی
                                      </th>
                                      <th className="w-[150px] !font-[B-Nazanin] text-[14px] text-center weedless-report-header">
                                        مقدار مصرف در هکتار
                                      </th>
                                      <th className="w-[150px] !font-[B-Nazanin] text-[14px] text-center weedless-report-header">
                                        زمان مصرف
                                      </th>
                                      <th className="w-[160px] !font-[B-Nazanin] text-[14px] text-center rounded-tl-[16px] weedless-report-header">
                                        علف های هرز قابل کنترل
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {grouped2.map((item, k) => {
                                      const uniqueInstructions = [
                                        ...new Set(
                                          item.weeds.map(
                                            (weed) =>
                                              weed?.effectiveHerbicide
                                                ?.instruction || ""
                                          )
                                        ),
                                      ];
                                      const weedNames = item.weeds.map(
                                        (weed) => weed?.name || ""
                                      );
                                      return (
                                        <tr
                                          key={k}
                                          className={`${
                                            k % 2 !== 0 && "bg-[#E9E9E9]"
                                          }`}
                                        >
                                          <td className="w-[120px] text-center !font-[B-Nazanin] text-[14px] font-semibold px-2">
                                            {item?.prescribedHerbicide?.brand}
                                            <br />
                                            {
                                              item?.prescribedHerbicide
                                                ?.formulation
                                            }
                                          </td>
                                          <td className="w-[130px] text-ellipsis text-center !font-[B-Nazanin] text-[14px] px-2 font-medium">
                                            {item?.prescribedHerbicide?.name}
                                          </td>
                                          <td className="w-[150px] text-center !font-[B-Nazanin] text-[14px] px-2 font-medium">
                                            {item?.prescribedHerbicide?.dosage}
                                          </td>
                                          <td className="w-[150px] text-center !font-[B-Nazanin] text-[14px] px-2 font-medium">
                                            {uniqueInstructions.join(" - ")}
                                          </td>
                                          <td className="w-[160px] text-center text-[14px] px-2 font-medium !font-[B-Nazanin]">
                                            {weedNames.join(" ، ")}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                                <div className="flex flex-col items-start p-[15px]">
                                  <div className="flex flex-row items-start gap-2">
                                    <StarOutlined className="mt-0.5" />
                                    <p className="!font-[B-Nazanin]">
                                      با توجه به منابع علمی، میزان اثر بخشی این
                                      نسخه روی{" "}
                                      {prescrptionWeeds.length === 1
                                        ? "علف هرز"
                                        : "علف های هرز"}{" "}
                                      <span className="font-bold">
                                        <u className="!font-[B-Nazanin]">
                                          {prescrptionWeeds.map((weed, k) =>
                                            prescrptionWeeds.length - 1 !== k
                                              ? `${
                                                  weed?.name
                                                } ${attackImpactRateConvertor(
                                                  weed?.attackImpactRate
                                                )}، `
                                              : `${
                                                  weed?.name
                                                } ${attackImpactRateConvertor(
                                                  weed?.attackImpactRate
                                                )} `
                                          )}
                                        </u>
                                      </span>{" "}
                                      است.
                                    </p>
                                  </div>
                                  {/* <p className='!font-[B-Nazanin] tracking-tight'><span className='font-bold !font-[B-Nazanin]'>غیر قابل اختلاط:</span> علف کش گالانت سوپر و علف کش پنترا قابلیت اختلاط با یکدیگر را ندارند و لازم است به صورت جداگانه سمپاشی شوند.</p> */}
                                  {/* <p className='!font-[B-Nazanin] text-[#222]'><span className='font-bold !font-[B-Nazanin]'>نکته:</span> علف کش پنترا برای ماهی ها و پرندگان سمیت زیادی دارد.</p> */}
                                </div>
                              </div>
                            </div>
                          );
                        case "generatedPrescriptionByAttackImpactRate":
                          prescrptionWeeds = [];
                          const grouped3 = groupPrescriptions(
                            weedsPrescriptionData?.data
                              ?.generatedPrescriptionByAttackImpactRate || []
                          );
                          grouped3.forEach((item) => {
                            item?.weeds?.forEach((weed) => {
                              prescrptionWeeds.push({
                                id: weed?.weedId,
                                name: weed?.name,
                                attackImpactRate:
                                  weed?.effectiveHerbicide?.attackImpactRate,
                              });
                            });
                          });
                          return (
                            <div
                              key={j}
                              id="prescriptionTable3"
                              className="flex flex-col items-start gap-2"
                            >
                              <p className="!font-[B-Nazanin] px-4 font-bold text-[#222] text-[20px]">
                                <span className="text-[#4E6F04] !font-[B-Nazanin]">
                                  نسخه پیشنهادی 3:
                                </span>{" "}
                                (بر اساس بیشترین اثر گذاری بر کنترل علف هرز)
                              </p>
                              <div className="flex flex-col items-start justify-start gap-3 border-[3px] border-solid rounded-[20px] border-weedless">
                                <table
                                  style={{
                                    borderCollapse: "separate",
                                    borderSpacing: 2,
                                  }}
                                >
                                  <thead>
                                    <tr>
                                      <th className="w-[120px] py-1 !font-[B-Nazanin] text-[14px] text-center rounded-tr-[16px] weedless-report-header">
                                        نام تجاری
                                      </th>
                                      <th className="w-[130px] !font-[B-Nazanin] text-[14px] text-center weedless-report-header">
                                        نام عمومی
                                      </th>
                                      <th className="w-[150px] !font-[B-Nazanin] text-[14px] text-center weedless-report-header">
                                        مقدار مصرف در هکتار
                                      </th>
                                      <th className="w-[150px] !font-[B-Nazanin] text-[14px] text-center weedless-report-header">
                                        زمان مصرف
                                      </th>
                                      <th className="w-[160px] !font-[B-Nazanin] text-[14px] text-center rounded-tl-[16px] weedless-report-header">
                                        علف های هرز قابل کنترل
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {grouped3.map((item, k) => {
                                      const uniqueInstructions = [
                                        ...new Set(
                                          item.weeds.map(
                                            (weed) =>
                                              weed?.effectiveHerbicide
                                                ?.instruction || ""
                                          )
                                        ),
                                      ];
                                      const weedNames = item.weeds.map(
                                        (weed) => weed?.name || ""
                                      );
                                      return (
                                        <tr
                                          key={k}
                                          className={`${
                                            k % 2 !== 0 && "bg-[#E9E9E9]"
                                          }`}
                                        >
                                          <td className="w-[120px] text-center !font-[B-Nazanin] text-[14px] font-semibold px-2">
                                            {item?.prescribedHerbicide?.brand}
                                            <br />
                                            {
                                              item?.prescribedHerbicide
                                                ?.formulation
                                            }
                                          </td>
                                          <td className="w-[130px] text-center !font-[B-Nazanin] text-[14px] px-2 font-medium">
                                            {item?.prescribedHerbicide?.name}
                                          </td>
                                          <td className="w-[150px] text-center !font-[B-Nazanin] text-[14px] px-2 font-medium">
                                            {item?.prescribedHerbicide?.dosage}
                                          </td>
                                          <td className="w-[150px] text-center !font-[B-Nazanin] text-[14px] px-2 font-medium">
                                            {uniqueInstructions.join(" - ")}
                                          </td>
                                          <td className="w-[160px] text-center text-[14px] px-2 font-medium !font-[B-Nazanin]">
                                            {weedNames.join(" ، ")}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                                <div className="flex flex-col items-start p-[15px]">
                                  <div className="flex flex-row items-start gap-2">
                                    <StarOutlined className="mt-0.5" />
                                    <p className="!font-[B-Nazanin]">
                                      با توجه به منابع علمی، میزان اثر بخشی این
                                      نسخه روی{" "}
                                      {prescrptionWeeds.length === 1
                                        ? "علف هرز"
                                        : "علف های هرز"}{" "}
                                      <span className="font-bold">
                                        <u className="!font-[B-Nazanin]">
                                          {prescrptionWeeds.map((weed, k) =>
                                            prescrptionWeeds.length - 1 !== k
                                              ? `${
                                                  weed?.name
                                                } ${attackImpactRateConvertor(
                                                  weed?.attackImpactRate
                                                )}، `
                                              : `${
                                                  weed?.name
                                                } ${attackImpactRateConvertor(
                                                  weed?.attackImpactRate
                                                )} `
                                          )}
                                        </u>
                                      </span>{" "}
                                      است.
                                    </p>
                                  </div>
                                  {/* <p className='!font-[B-Nazanin] tracking-tight'><span className='font-bold !font-[B-Nazanin]'>غیر قابل اختلاط:</span> علف کش گالانت سوپر و علف کش پنترا قابلیت اختلاط با یکدیگر را ندارند و لازم است به صورت جداگانه سمپاشی شوند.</p> */}
                                  {/* <p className='!font-[B-Nazanin] text-[#222]'><span className='font-bold !font-[B-Nazanin]'>نکته:</span> علف کش پنترا برای ماهی ها و پرندگان سمیت زیادی دارد.</p> */}
                                </div>
                              </div>
                            </div>
                          );
                        default:
                          break;
                      }
                    })}
                  </div>
                </div>
                <div className="footer w-full flex flex-col justify-start items-center relative bottom-0">
                  <img
                    className="absolute bottom-0 z-[2]"
                    src={footerImage}
                    width="750px"
                    alt="footer-image"
                  />
                  <img
                    className="absolute bottom-2 left-[30px] z-[3]"
                    src={footerTitle}
                    alt="footer-image"
                  />
                  <span className="absolute bottom-[5px] left-[30px] z-[3] text-[12px] font-bold text-[#fff] !font-sans">
                    کد گزارش: {prescription?.prescriptionCode}
                  </span>
                  <span className="absolute bottom-[5px] right-[15px] z-[3] text-[18px] font-semibold text-[#fff]">
                    {++pageNumber}
                  </span>
                </div>
              </div>
            </div>
          )}
          <div className="flex flex-col">
            <Button
              className="button-neo h-fit !text-[#333] hover:brightness-105 fixed top-[20px] right-[100px] max-lg:right-[32px] px-8 text-[18px] w-[150px]"
              id="print-button"
              onClick={() => window.print()}
            >
              <p>پرینت گزارش</p>
            </Button>
            <Button
              className="button-neo h-fit !text-[#333] hover:brightness-105 fixed top-[65px] right-[100px] max-lg:right-[32px] px-8 text-[18px] w-[150px]"
              id="back-button"
              onClick={() => window.close()}
            >
              <p> بازگشت</p>
            </Button>
          </div>
        </div>
      )}
    </>
  );
}
export default WeedLessReport;
